import { render, staticRenderFns } from "./metadata.vue?vue&type=template&id=061a2cda&scoped=true&lang=html"
import script from "./metadata.vue?vue&type=script&lang=js"
export * from "./metadata.vue?vue&type=script&lang=js"
import style0 from "./metadata.vue?vue&type=style&index=0&id=061a2cda&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061a2cda",
  null
  
)

export default component.exports